import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BluechatDelivery} from '../../shared/bluechat-delivery.model';
import {BluechatService} from '../../bluechat.service';
import { NavigationLinkService } from '../../../shared/services/navigation-link.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-bluechat-delivery',
  templateUrl: './bluechat-delivery.component.html',
  styleUrls: ['./bluechat-delivery.component.scss']
})
export class BluechatDeliveryComponent {
  @Input() public delivery: BluechatDelivery
  @Input() public selected: boolean;
  @Input() public userCanCreateNote = false;
  @Input() public carrierHasBluechat = false;
  @Input() public loadStatusAllowNoteCreation = false;
  @Input() public loadStatusI18nKey: string;

  @Output() public select            = new EventEmitter<boolean>();
  @Output() public createNoteClicked = new EventEmitter<void>();

  public noteSummaryOpened = false;
  public dateFormat: string = BluechatService.DATE_FORMAT;

  canManageLocations = false;
  canReadEtaDetails = false;

  showEtaDetails = false;

  deliveryNumberForEtaDetails: string;
  targetGlidForEtaDetails: string;
  latestEtaReportIdForEtaDetails: string;

  constructor(
    private authService: AuthenticationService,
    public link: NavigationLinkService
  ) {
    this.canManageLocations = this.authService.canManageLocations();
    this.canReadEtaDetails = this.authService.canReadEtaDetails();
  }

  showEtaDetailsForDelivery(deliveryNumber: string, latestEtaReportId: string, targetGlid: string) {
    this.deliveryNumberForEtaDetails = deliveryNumber;
    this.targetGlidForEtaDetails = targetGlid;
    this.latestEtaReportIdForEtaDetails = latestEtaReportId;
    this.showEtaDetails = true;
  }

  hideEtaDetails() {
    this.showEtaDetails = false;
    this.targetGlidForEtaDetails = null;
    this.deliveryNumberForEtaDetails = null;
  }
}
